import * as React from "react"
import * as styles from "./styles.css"

export type SpinnerLightProps = {
  className?: string
}

export function SpinnerLight({ className }: SpinnerLightProps) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <clipPath id="myClip">
        <path d="M18.3332 9.99984C18.3332 14.6022 14.6022 18.3332 9.99984 18.3332C5.39746 18.3332 1.6665 14.6022 1.6665 9.99984C1.6665 5.39746 5.39746 1.6665 9.99984 1.6665C14.6022 1.6665 18.3332 5.39746 18.3332 9.99984ZM4.58317 9.99984C4.58317 12.9914 7.00829 15.4165 9.99984 15.4165C12.9914 15.4165 15.4165 12.9914 15.4165 9.99984C15.4165 7.00829 12.9914 4.58317 9.99984 4.58317C7.00829 4.58317 4.58317 7.00829 4.58317 9.99984Z" />
      </clipPath>
      <foreignObject
        x="0"
        y="0"
        width="20px"
        height="20px"
        id="heart"
        clipPath="url(#myClip)"
        clipRule="evenodd"
      >
        <div className={styles.main} />
      </foreignObject>
    </svg>
  )
}
